<div class="box-content report">
  <mat-card class="mat-elevation-z8" fxLayout="column" fxLayoutGap="20px">
    <mat-card-header fxLayout="column" fxLayoutGap="20px">
      <div
        fxLayout="column"
        fxLayout.gt-sm="row"
        fxLayoutAlign="start strech"
        fxLayoutAlign.gt-sm="space-between center"
        fxLayoutGap="10px"
      >
        <mat-card-title
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="10px"
          style="width: 100%"
        >
          <menu-header [menuTopic]="menuTopic"></menu-header>
          <mat-divider></mat-divider>
        </mat-card-title>
      </div>
      <mat-divider></mat-divider>
    </mat-card-header>

    <mat-card-content fxLayout="column" fxLayoutAlign="start strech">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="center center" style="gap: 10px">
          <mat-form-field
            class="example-full-width"
            appearance="outline"
            fxFlex="100"
            fxFlex.gt-sm="200px"
          >
            <mat-label>
              {{ "view_value.room" | translate }} /
              {{ "view_value.shop_name" | translate }}
            </mat-label>
            <input
              type="text"
              aria-label="Number"
              matInput
              [formControl]="myControl"
              [matAutocomplete]="auto"
             (keydown.enter)="meterNameSearch()"
            />
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
              <mat-option
                *ngFor="let option of filteredOptions | async"
                [value]="option"
              >
                {{ option }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <div
            fxLayout="row nowrap"
            fxLayoutAlign="end center"
            fxLayoutGap="10px"
          >
            <div
              fxLayout="row nowrap"
              fxLayoutAlign="end center"
              fxLayoutGap="10px"
              [formGroup]="formMeter"
            >
              <mat-form-field appearance="outline">
                <mat-label>
                  {{ "view_value.sensor_type" | translate }}
                </mat-label>
                <mat-select formControlName="sensor_type">
                  @for (item of sensor_type_list; track item) {
                    <mat-option [value]="item">
                      {{ item | titlecase }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div
              [formGroup]="campaignOne"
              fxLayout="row"
              fxLayoutAlign="space-between center"
              fxLayoutGap="10px"
            >
              <mat-form-field
                appearance="outline"
                fxFlex="100"
                fxFlex.gt-sm="180px"
              >
                <mat-label>
                  {{ "view_value.start_date" | translate }}

                  <!-- วันที่สิ้นสุด -->
                </mat-label>
                <input
                  matInput
                  [matDatepicker]="pickerstart"
                  formControlName="select_start_time"
                  (click)="pickerstart.open()"
                  readonly
                />
                <mat-hint style="color: black">
                  {{ "view_value.d_m_yyyy" | translate }}
                  <!-- ว/ด/ปปปป -->
                </mat-hint>
                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickerstart"
                ></mat-datepicker-toggle>
                <mat-datepicker #pickerstart></mat-datepicker>
              </mat-form-field>

              <app-time-picker
                formControlName="start_time"
                [minuteStep]="5"
              ></app-time-picker>

              <mat-form-field
                appearance="outline"
                fxFlex="100"
                fxFlex.gt-sm="180px"
              >
                <mat-label>
                  <!-- วันที่สิ้นสุด -->
                  {{ "view_value.end_date" | translate }}
                </mat-label>
                <input
                  matInput
                  [matDatepicker]="pickerend"
                  formControlName="select_end_time"
                  (click)="pickerend.open()"
                  readonly
                  [min]="
                    campaignOne.value.select_start_time
                      ? campaignOne.value.select_start_time
                      : ''
                  "
                />
                <mat-hint style="color: black">
                  {{ "view_value.d_m_yyyy" | translate }}
                  <!-- ว/ด/ปปปป -->
                </mat-hint>
                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickerend"
                ></mat-datepicker-toggle>
                <mat-datepicker #pickerend></mat-datepicker>
              </mat-form-field>

              <app-time-picker
                formControlName="end_time"
                [minuteStep]="5"
              ></app-time-picker>

              <button
                [disabled]="!campaignOne.valid"
                [ngClass]="{ 'btn-primary': campaignOne.valid === true }"
                mat-stroked-button
                type="button"
                (click)="checkData(); filterForm.reset()"
              >
                <mat-icon> search </mat-icon>
                {{ "view_value.search" | translate }}
              </button>
            </div>
          </div>
          <div>
            <button
              class="btn-outline"
              mat-raised-button
              type="button"
              (click)="filterForm.reset()"
            >
              <mat-icon>history</mat-icon>
              {{ "view_value.reset" | translate }}
            </button>
          </div>
        </div>
      </div>

      <div
        style="
          padding: 16px 0px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div>
          <ng-container *ngIf="dataSource?.data?.length as totalLength">
            {{ pageIndex * pageSize + 1 }} –
            {{
              (pageIndex + 1) * pageSize > totalLength
                ? totalLength
                : (pageIndex + 1) * pageSize
            }}
            {{ "view_value.from" | translate }} {{ totalLength }}
            {{ "view_value.search_result" | translate }}
          </ng-container>

          <ng-container *ngIf="!dataSource?.data?.length">
            0 {{ "view_value.from" | translate }}
            {{ "view_value.search_result" | translate }}
          </ng-container>
        </div>

        <div>
          <button
            mat-raised-button
            [disabled]="!onDownload"
            [ngClass]="{ 'btn-primary': onDownload }"
            (click)="onExportExcel()"
          >
            <mat-icon>download</mat-icon>
            {{ "view_value.download_excel" | translate }}
            <ng-container *ngIf="selectedCount > 0">
              ({{ selectedCount }} {{ "view_value.item" | translate }})
            </ng-container>
          </button>
        </div>
      </div>

      <div style="overflow: auto">
        <table mat-table [dataSource]="dataSource" matSort class="hearder">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                class="checkbox-white"
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
              ></mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox
                class="checkbox-primary"
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)"
              ></mat-checkbox>
            </td>
          </ng-container>
          <ng-container
            *ngFor="let column of columns; trackBy: trackColumn"
            [matColumnDef]="column.key"
          >
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [disabled]="!column.sortable"
              [class]="column.widthClass || ''"
            >
              {{ column.label | translate }}
            </th>

            <td mat-cell *matCellDef="let element; let i = index">
              <ng-container [ngSwitch]="column.type">
                <ng-container *ngSwitchCase="'number'">
                  {{
                    getCellValue(element, column, i)
                      | number: getDecimalInfo(column)
                  }}
                </ng-container>

                <ng-container *ngSwitchCase="'status'">
                  <div
                    class="status"
                    [ngClass]="getBgColor(getCellValue(element, column, i))"
                  >
                    {{ getCellValue(element, column, i) }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'action'">
                  <button
                    [disabled]="!onDownload"
                    [ngClass]="{ 'btn-primary': onDownload === true }"
                    mat-stroked-button
                    type="button"
                    (click)="onExportRowExcel(element)"
                  >
                    <mat-icon>download</mat-icon>Excel
                  </button>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  {{ getCellValue(element, column, i) }}
                </ng-container>
              </ng-container>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

          <tr class="mat-row no-data-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length">
              <div class="no-data-container">
                <mat-icon class="no-data-icon">inbox</mat-icon>
                <p>{{ "view_value.no_data" | translate }}</p>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <mat-paginator
        style="padding-top: 18px"
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        aria-label="Select page"
        class="paginator"
        (page)="onPageChange($event)"
      ></mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
